import React, { useState } from "react";
import { useStyles } from "./RoutineHistoryButton.styles";
import RoutineHistory from "../../../../components/RoutineService/RoutineHistory";
import { Button, Drawer, Divider, Box } from "@material-ui/core";
import clsx from "clsx";

const RoutineHistoryButton = ({ routineId }) => {
    const classes = useStyles();
    const [historyOpen, setHistoryOpen] = useState(false);

    const openHistoryDrawer = () => {
        setHistoryOpen(true);
    }

    const drawerClose = () => setHistoryOpen(false);

    return (
        <>
            <div>
                <Button
                    key="sync-history-button"
                    variant="outlined"
                    color="primary"
                    className={clsx(`sync-history-button`, classes.historyButtons)}
                    onClick={openHistoryDrawer}
                >
                    HISTORY
                </Button>
            </div>
            <Drawer
                className={clsx("drawer", classes.drawer)}
                anchor="right"
                open={historyOpen}
                classes={{
                    paper: classes.drawerPaper,
                    root: classes.drawer,
                }}
                onClose={drawerClose}
            >
                <RoutineHistory
                    autoSyncRoutineId={routineId ?? 0}
                    isAutoSyncRoutine={true}
                />

                <Box className={classes.bottomButtons}>
                    <div className={classes.divider}><Divider /></div>
                    <div className={classes.buttonWrapper}>
                        <div className={classes.buttonContainer}>
                            <Button
                                className={clsx("closeBtn", classes.closeButton)}
                                name="close"
                                variant="contained"
                                onClick={drawerClose}
                                type="button"
                            >
                                Close
                            </Button>
                        </div>
                    </div>
                </Box>
            </Drawer>
        </>
    );
}

export default RoutineHistoryButton;